function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import { Copyable } from "../../../../../components/Copyable";
import { DescriptionList, Flex, Text } from '@applyboard/crystal-ui';
import { useApplicationStudent } from "../../../data/student";
import { LabelledFlag } from "../../LabelledFlag";
import { SideBarDescriptionList } from "../SideBarDescriptionList";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export function EducationBackground(_ref) {
  var copyEnabled = _ref.copyEnabled;
  var _useApplicationStuden = useApplicationStudent(),
    student = _useApplicationStuden.student;
  var attendedSchools = student.attendedSchools;
  return _jsxs(Flex, {
    direction: "column",
    gap: 6,
    children: [_jsx(EducationSummary, {
      copyEnabled: copyEnabled
    }), attendedSchools.map(function (school, index) {
      return _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsxs(Text, {
          variant: "labelL",
          children: ["SCHOOL ATTENDED #", index + 1]
        }), _jsx(AttendedSchoolSection, {
          school: school,
          copyEnabled: copyEnabled
        })]
      }, index);
    })]
  });
}
function EducationSummary(_ref2) {
  var _student$profile$educ;
  var copyEnabled = _ref2.copyEnabled;
  var _useApplicationStuden2 = useApplicationStudent(),
    student = _useApplicationStuden2.student;
  var educationLevelName = (_student$profile$educ = student.profile.educationSummary.educationLevels.find(function (level) {
    return level.id === student.profile.educationSummary.educationLevelId;
  })) === null || _student$profile$educ === void 0 ? void 0 : _student$profile$educ.name;
  var gradingScheme = [].concat(_toConsumableArray(student.profile.educationSummary.gradingSchemes), [{
    id: 0,
    name: "Non-standard 0 - ".concat(student.profile.educationSummary.gradeScale),
    type: 'numerical',
    max: student.profile.educationSummary.gradeScale
  }]).find(function (scheme) {
    return scheme.id === student.profile.educationSummary.gradingScheme;
  });
  return _jsxs(SideBarDescriptionList, {
    children: [_jsx(DescriptionList.Term, {
      children: "Education"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: educationLevelName || '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Graduated?"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: student.profile.educationSummary.graduated ? 'Yes' : 'No'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Country of education"
    }), _jsx(DescriptionList.Details, {
      children: student.profile.educationSummary.educationCountry ? _jsx(LabelledFlag, {
        countryCode: student.profile.educationSummary.educationCountry,
        copyEnabled: copyEnabled
      }) : _jsx(Text, {
        intent: "secondary",
        children: "--"
      })
    }), _jsx(DescriptionList.Term, {
      children: "Grading scheme"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: gradingScheme ? gradingScheme.name : '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Grade"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: _jsx(Grade, {
          gradingScheme: gradingScheme,
          grade: student.profile.educationSummary.grade
        })
      })
    })]
  });
}
function Grade(_ref3) {
  var gradingScheme = _ref3.gradingScheme,
    grade = _ref3.grade;
  if (typeof grade === 'undefined' || grade === null) {
    return _jsx(_Fragment, {
      children: "--"
    });
  }
  if (!gradingScheme) {
    return _jsx(_Fragment, {
      children: "--"
    });
  }
  if (gradingScheme.type === 'numerical') {
    return _jsxs(_Fragment, {
      children: [grade, " / ", gradingScheme.max]
    });
  }
  return _jsx(_Fragment, {
    children: grade
  });
}
function AttendedSchoolSection(_ref4) {
  var copyEnabled = _ref4.copyEnabled,
    school = _ref4.school;
  return _jsxs(SideBarDescriptionList, {
    children: [_jsx(DescriptionList.Term, {
      children: "School"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: school.schoolName ? school.schoolName : '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Level"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: school.level.toString()
      })
    }), _jsx(DescriptionList.Term, {
      children: "Language"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: school.language ? school.language : '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Attended"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: school.startDate ? formatAttendedDate(school.startDate, school.endDate) : '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Address"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: formatFullAddress(school.schoolAddress) ? formatFullAddress(school.schoolAddress) : '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Degree name"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: school.degreeName ? school.degreeName : '--'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Graduated?"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: school.hasGraduated ? 'Yes' : 'No'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Certificate awarded?"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: school.degreeAwarded ? 'Yes' : 'No'
      })
    }), _jsx(DescriptionList.Term, {
      children: "Graduation date"
    }), _jsx(DescriptionList.Details, {
      children: _jsx(Copyable, {
        disabled: !copyEnabled,
        children: school.dateGraduated ? formatDate(school.dateGraduated) : '--'
      })
    })]
  });
}
function formatFullAddress(address) {
  var addressParts = [];
  if (address.street) addressParts.push(address.street);
  if (address.city) addressParts.push(address.city);
  if (address.province) addressParts.push(address.province);
  if (address.country) addressParts.push(address.country);
  if (address.postal) addressParts.push(address.postal);
  return addressParts.join(', ');
}
function formatAttendedDate(startDate, endDate) {
  return "".concat(formatDate(startDate), " - ").concat(endDate ? formatDate(endDate) : 'Present');
}
function formatDate(date) {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC'
  });
}